import axios from 'axios';
import {
  helperGetApiHeaders,
  helperGetApiRoute,
  helperConvertApiRoute,
  axiosErrorHandler,
} from 'helpers/ApiHelper';

export const FETCH_SHOWS = 'FETCH_SHOWS';
export const RESET_STORE_SHOWS = 'RESET_STORE_SHOWS';
const PAGE_TYPE_RETIRED_SHOWS = 'retiredShows';
const PAGE_TYPE_SHOWS = 'shows';
export const SET_SUGGESTED_TAB = 'SET_SUGGESTED_TAB';

export function fetchShows({
  accessToken,
  url = '',
  filteredPanel = null,
  tabId = '',
  deviceId = '',
  isRetiredShowsPage = false,
}) {
  const pageType = isRetiredShowsPage ? PAGE_TYPE_RETIRED_SHOWS : PAGE_TYPE_SHOWS;
  const route = helperConvertApiRoute(url) || helperGetApiRoute(pageType);
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
  let payload;
  if (filteredPanel) {
    payload = { data: filteredPanel, tabId };
  } else {
    payload = axios.get(route, headers).catch(axiosErrorHandler);
  }

  return {
    type: FETCH_SHOWS,
    payload,
  };
}

export function resetStore() {
  return {
    type: RESET_STORE_SHOWS,
  };
}

export function setSuggestedTab({ suggestedNetwork, suggestedFilter }) {
  return {
    type: SET_SUGGESTED_TAB,
    payload: {
      suggestedNetwork,
      suggestedFilter,
    },
  };
}
